import { computed as g, openBlock as l, createBlock as a, normalizeProps as f, guardReactiveProps as h, withCtx as w, createElementVNode as s, normalizeClass as n, createElementBlock as r, createCommentVNode as i, renderSlot as d, toDisplayString as c } from "vue";
import y from "../section-single/section-single.vue.js";
import { sectionProps as S } from "../mixins/useSectionProps.js";
import { themeProp as k } from "../../../composables/useTheme.js";
import b from "../../../atoms/tag/tag.vue.js";
import p from "../../../molecules/link/link.vue.js";
/* empty css                   */
import v from "../../../_virtual/_plugin-vue_export-helper.js";
import x from "../../../utils/validators/link.js";
const C = ["textContent"], B = ["textContent"], u = "DsSectionGroup", z = /* @__PURE__ */ Object.assign({
  name: u
}, {
  __name: "section-group",
  props: {
    ...k,
    ...S,
    /**
     * Section Title
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Section Subtitle
     */
    subtitle: {
      type: String,
      default: ""
    },
    /**
     * Section Link
     */
    link: {
      type: Object,
      default: null,
      validator: (e) => x(e)
    },
    /**
     * Section Eyebrow
     */
    eyebrow: {
      type: String,
      default: ""
    },
    /**
     * Section Tag
     */
    tagColor: {
      type: String,
      default: "green"
    },
    /**
     * Center content
     */
    centered: {
      type: Boolean,
      default: !1
    },
    /**
     * Enlarge Title
     */
    withTitleSizeLarge: {
      type: Boolean,
      default: !1
    },
    withoutTextPadding: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const o = e, m = g(() => o.eyebrow || o.title || o.subtitle || o.link);
    return (t, T) => (l(), a(y, f(h({ withSpace: t.withSpace, withSpaceTop: t.withSpaceTop, withSpaceBottom: t.withSpaceBottom, spaceOptionsSmall: t.spaceOptionsSmall, spaceOptionsMedium: t.spaceOptionsMedium, fullScreen: t.fullScreen, theme: t.theme })), {
      default: w(() => [
        s("div", {
          class: n({ "ds-container": t.fullScreen })
        }, [
          m.value ? (l(), r("div", {
            key: 0,
            class: n(["ds-grid", {
              "ds-justify-content-center": e.centered
            }])
          }, [
            s("div", {
              class: n(["ds-grid__col ds-md-grid__col--8 ds-grid__col--12 ds-lg-grid__col--8 ds-margin-bottom-48", { "ds-padding-left-0": e.withoutTextPadding }])
            }, [
              e.eyebrow ? (l(), a(b, {
                key: 0,
                label: e.eyebrow,
                color: e.tagColor,
                class: n(["ds-margin-bottom-24", {
                  "centered-tag": e.centered
                }])
              }, null, 8, ["label", "color", "class"])) : i("", !0),
              d(t.$slots, "title", {}, () => [
                e.title ? (l(), r("h2", {
                  key: 0,
                  class: n(["ds-heading", {
                    "ds-margin-bottom-12": e.subtitle,
                    "ds-text-align-center": e.centered,
                    "ds-heading-large": e.withTitleSizeLarge
                  }]),
                  "data-j-title": "",
                  textContent: c(e.title)
                }, null, 10, C)) : i("", !0)
              ], !0),
              d(t.$slots, "subtitle", {}, () => [
                e.subtitle ? (l(), r("p", {
                  key: 0,
                  class: n(["ds-text", { "ds-text-align-center": e.centered }]),
                  "data-j-subtitle": "",
                  textContent: c(e.subtitle)
                }, null, 10, B)) : i("", !0)
              ], !0),
              e.link ? (l(), a(p, {
                key: 1,
                "tracking-data": { "component-name": u, text: e.link.text, title: e.title },
                url: e.link.url,
                "lazy-url-endpoint": e.link.lazyUrlEndpoint,
                content: e.link.text,
                nuxt: e.link.nuxt,
                "open-in-new-window": e.link.openInNewWindow,
                "icon-right": { name: "chevron-right-small", category: "arrows" },
                class: n(["ds-margin-top-24", { "ds-display-flex ds-justify-content-center": e.centered }])
              }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "content", "nuxt", "open-in-new-window", "class"])) : i("", !0)
            ], 2)
          ], 2)) : i("", !0)
        ], 2),
        d(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16));
  }
}), I = /* @__PURE__ */ v(z, [["__scopeId", "data-v-8a214632"]]);
export {
  I as default
};
